<script>
import {routerParams} from "@/libs/utils/routerParams";
import Model from "@/views/front/scds/homepage/components/model.vue";
import Layout from "@/views/front/jsf35/subsystems/layout";
import AppCollapseItem from "@core/components/app-collapse/AppCollapseItem.vue";
import AppCollapse from "@core/components/app-collapse/AppCollapse.vue";
import ModelInfoCard from "@/views/front/jsf35/subsystems/layout/components/ModelInfoCard.vue";
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import router from "@/router";
import VueSlider from "vue-slider-component";
//jsf工程中心界面
import OperationsLayout from "@/views/front/jsf35/operations";
import store from "@/store";
import "vue-slider-component/theme/default.css";
import system_model from "@/views/front/scds/subsystems/components/data/system_model.json"
import system_params from "@/views/front/scds/subsystems/components/data/params.json"
import dtDate from '@/views/front/scds/subsystems/components/data/dtDate.json'
import subSystemData from '@/views/front/scds/subsystems/components/data/subSystemData.json';
import system_dtxt from '@/views/front/scds/subsystems/components/data/system_dtxt.json'; // 电梯系统详细信息展示数据
import system_afxt from '@/views/front/scds/subsystems/components/data/system_afxt.json';
import data_check from '@/views/front/scds/subsystems/components/data/巡检Demo数据.json'; //维修保养中的巡检的demo数据
import * as BABYLON from "@babylonjs/core";
import * as GUI from '@babylonjs/gui'
//引入@babylonjs/loaders模块，用于加载gltf文件
import "@babylonjs/loaders";
import flvjs from "flv.js";
import operations from "@/views/front/jsf35/operations/index.vue";
import moment from "moment/moment";
import vSelect from "vue-select";
import LeftMenu from "@/views/front/jsf35/subsystems/layout/components/LeftMenu.vue";
import dParams from "@/views/front/scds/subsystems/components/data/params.json";

let baseUrl = "https://cabrenergy-v2-1255710621.cos.ap-beijing.myqcloud.com/"

let sUrl = '';
//存储设备模型场景
let sub_scene = null;
let _engine = null;
export default {
  name: "ScdsSubsystem",
  components: {
    LeftMenu,
    ModelInfoCard,
    AppCollapse,
    AppCollapseItem,
    Layout,
    Model,
    VueSlider,
    VuePerfectScrollbar,
    OperationsLayout,
    vSelect,
  },
  data() {
    return {
      system_key: routerParams("system_key"),
      left_nav_list: [],
      sub_system_list: [
        {key: "kttf", name: "空调通风", icon: "wind"},
        {key: "zlxt", name: "冷源系统", icon: "snow2"},
        {key: "grxt", name: "热源系统", icon: "hdd-fill"},
        {key: "jps", name: "给排水", icon: "droplet"},
        {key: "bpd", name: "变配电", icon: "lightning-fill"},
        {key: "dtxt", name: "电梯系统", icon: "box-arrow-up"},
        {key: "ggzm", name: "公共照明", icon: "lightbulb-fill"},
        {key: "yjzm", name: "应急照明", icon: "tropical-storm"},
        {key: "hjjc", name: "环境监测", icon: "thermometer-half"},
        {key: "xfxt", name: "消防系统", icon: "shield-fill-exclamation"},
        {key: "afxt", name: "安防系统", icon: "lock-fill"},
        {key: "ybgc", name: "隐蔽工程", icon: "bezier"},
      ],
      sub_system_hover: "",
      add_system_list: [
        {key: '/e8480b59', name: "能源管理", type: "panel-group", icon: "lightning-charge"},
        {key: '/970eed9d', name: "碳排管理", type: "panel-group", icon: "arrow-repeat"},
        {key: 'project-scds-engineering-center', name: "工程中心", type: "", icon: "wrench"},
        {key: 'project-scds-operations-center', name: "运营中心", type: "", icon: "x-diamond-fill"},
        {key: 'project-scds-security-center', name: "安保中心", type: "", icon: "shield-check"},
        {key: 'project-scds-service-center', name: "服务中心", type: "", icon: "person-fill"},
        {key: 'index-ledger-list', type: "", name: "资产管理", icon: "wallet"},
      ],
      electrical_floor: [],
      modelInfo: {
        equip_id: 39,
        system_type: "air-conditioning-ventilation",
        equip_name: "PF-B1-1自行车库排风",
        equip_key: "equipment_PF-B1-1",
        equip_meter_code: "JSF_KTTF_B1_N_PF-B1-1",
        ip_address: null,
        floor: "B1",
        detail_model_key: "Detail/air-pipe/air-pipe",
        model_dbids: null,
        model_rotate: "310,837,-19",
        model_equip_status_config: null,
        group_lvl_1: "排风机",
        group_lvl_2: "B1",
        group_lvl_3: null,
        location: null,
        image: null,
        project_id: 72,
        error_handle: null,
        params: [
          {
            param_name: "PF-B1-1-故障报警",
            param_code: "EF-F",
            unit: "正常||故障",
            cur_value: 0,
            time: "2024-06-11 14:17:36",
            meter_code: "JSF_KTTF_B1_N_PF-B1-1_EF-F",
            tag_name: "PF-B1-1-EF-F",
            is_control: null,
          },
          {
            param_name: "PF-B1-1-启/停控制",
            param_code: "EF-C",
            unit: "启动||停止",
            cur_value: 0,
            time: "2024-06-11 14:17:36",
            meter_code: "JSF_KTTF_B1_N_PF-B1-1_EF-C",
            tag_name: "PF-B1-1-EF-C",
            is_control: 1,
          },
          {
            param_name: "PF-B1-1-手/自动状态",
            param_code: "EF-AM",
            unit: "手动||自动",
            cur_value: 1,
            time: "2024-06-11 14:17:36",
            meter_code: "JSF_KTTF_B1_N_PF-B1-1_EF-AM",
            tag_name: "PF-B1-1-EF-AM",
            is_control: null,
          },
          {
            param_name: "PF-B1-1-运行状态",
            param_code: "EF-S",
            unit: "停机||运行",
            cur_value: 0,
            time: "2024-06-11 14:17:36",
            meter_code: "JSF_KTTF_B1_N_PF-B1-1_EF-S",
            tag_name: "PF-B1-1-EF-S",
            is_control: null,
          },
        ],
        title: "PF-B1-1自行车库排风",
        model: {
          path: "Detail/air-pipe/air-pipe",
          dbIds: null,
        },
      },
      maintainItems: [
        {
          'ID': 1, '名称': '常规保养', '日期': '2024-03-01',
        },
        {
          'ID': 2, '名称': '常规保养', '日期': '2023-03-05',
        },
        {
          'ID': 3, '名称': '常规保养', '日期': '2022-02-28',
        },
        {
          'ID': 4, '名称': '常规保养', '日期': '2024-03-02',
        },
        {
          'ID': 5, '名称': '常规保养', '日期': '2024-03-08',
        },
      ], //保养
      repaireItems: [
        {
          'ID': 1, '名称': '风机叶轮更换', '日期': '2024-03-01',
        },
        {
          'ID': 2, '名称': '电机维修', '日期': '2023-03-05',
        },
      ], //维修
      faultItems: [
        {
          'ID': 1, '名称': '风机故障', '时间': '2024-03-01 08:23:56',
        },
        {
          'ID': 2, '名称': '电机故障', '时间': '2023-03-05 04:39:26',
        },
      ], //故障
      checkItems: data_check, //巡检
      sidebarVisible: false,
      subSystemParam: [],
      dtDate: dtDate,
      isModel: false,
      subSystemData: subSystemData,
      bastUrl: 'https://cabrenergy-v2-1255710621.cos.ap-beijing.myqcloud.com/bim/82/Detail/',
      system_model: system_model,
      floor_list: ['RF', 'F30', 'F29', 'F28', 'F27', 'F26', 'F25', 'F24', 'F23', 'F22', 'F21', 'F20', 'F19', 'F18/5', 'F18', 'F17', 'F16', 'F15', 'F14', 'F13', 'F12', 'F11', 'F10', 'F9', 'F8', 'F7', 'F6', 'F5', 'F4', 'F3', 'F2', 'F1', 'B1', 'B2', 'B3',],
      system_dtxt: system_dtxt,
      system_dtxt_checked: system_dtxt, //全部电梯信息展示选择的数据
      isShowParams: true,
      system_afxt: [], //监控轮巡弹窗可选择的对象
      system_afxt_floor: '',
      system_afxt_checked: [], //监控轮巡已选择的对象
      dialogData: [],  //设备大样图弹窗展示的参数
      isShowEfficientRoom: false, //高效机房侧边栏是否展示
      efficientRoom_loading: false, //加载展示
      videoUrl: '',
      isSystButtonDisabled:false, // 左侧按钮禁用
      isFloorButtonDisabled:false,
      isDeviceButtonDisabled:false, 
      // isFloorButtonDisabled:false, 
      currentFloor:'',
      currentDevice:'',
      OmmData:{
        "title": 'null',
        "data": null,
        "fields": null,
      }, //运维监测弹窗显示的数据
      otherSystemData:{
        "equip_name": null,
        "floor": null,
        'tableList': null,
        "fields": [
          'id',
          {key:'equip_name',label: '设备名称'},
          {key:'equip_code',label: '设备编号'},
          {key:'floor',label:'楼层'},
          {key:'state',label: '参数状态'},
          '操作'
        ],
        "isShow": false,
      },//设备列表查询
      isShowCanvas: true, //消防系统地板报警侧边栏中是否展示画布
    }
  },
  methods: {
    // 子系统切换按钮禁用
    changeSysButtonDisabled(value){
      this.isSystButtonDisabled = value
    },
    // 楼层切换按钮禁用
    changeFloorButtonDisabled(value){
      this.isFloorButtonDisabled = value
    },
    // 设备切换按钮禁用
    changeDeviceButtonDisabled(value){
      this.isDeviceButtonDisabled = value
    },
    // 点击子系统
    clickSys(key) {
      if (this.system_key === key) {
        this.showSecondNav()
      } else {
        this.currentFloor = ''
        this.currentDevice = ''
        this.system_key = key;
        this.$refs.modelRef.loadSubsystemMeshs(key)
      }
    },
    showSecondNav() {
      this.sub_system_hover = this.system_key
    },
    // 点击楼层
    clickFloor(floor) {
      this.currentFloor = floor
      this.$refs.modelRef.loadFloorMeshs(floor)
    },
    // 左侧菜单json处理
    handleJson() {
      let data = system_model
      let tree = {}
      data.map(item => {
        item.floor = item.floor === 'F3/5' ? 'F3' : item.floor
        // 设备子项
        let equip_item = {
          equip_name: item.equip_name,
          equip_key: item.equip_key,
          equip_code: item.equip_code,
        }
        // 楼层子项
        let floor_item = {
          floor: item.floor,
          // 楼层
          list: [equip_item,]
        }
        // 设备类型子项
        let equip_type_item = {
          equip_type: item.equip_type,
          equip_type_key: item.equip_type_key,
          // 楼层分类
          floor: {
            [item.floor]: floor_item
          }
        }

        if (!(item.system_key in tree)) {
          tree[item.system_key] = {
            system: item.system,
            system_key: item.system_key,
            // 设备分类
            equipment: {
              [item.equip_type_key]: equip_type_item
            },
            // 楼层列表
            floor: [item.floor,]
          }
        } else {
          // 楼层列表
          tree[item.system_key].floor = [...new Set([...tree[item.system_key].floor, item.floor])]
          tree[item.system_key].floor
          // 设备分类
          if (item.equip_type_key in tree[item.system_key].equipment) {
            // 楼层分类
            if (item.floor in tree[item.system_key].equipment[item.equip_type_key].floor) {
              tree[item.system_key].equipment[item.equip_type_key].floor[item.floor].list.push(equip_item)
            } else {
              tree[item.system_key].equipment[item.equip_type_key].floor[item.floor] = floor_item
            }
          } else {
            tree[item.system_key].equipment[item.equip_type_key] = equip_type_item
          }
        }
      })
      Object.entries(tree).forEach(([key, value]) => {
        tree[key].floor = this.sortFloor(value.floor)
        Object.entries(tree[key].equipment).forEach(([key1, value1]) => {
          let sortedKeys = this.sortFloor(Object.keys(value1.floor))
          let sortedObj = {}
          sortedKeys.forEach(k => {
            sortedObj[k] = value1.floor[k]
          })
          tree[key].equipment[key1].floor = sortedObj
        })
      });
      this.left_nav_list = tree
      console.log('treeArr', tree);
    },
    // 楼层排序
    sortFloor(arr) {
      let floors = [...arr]
      if (floors.length > 1) {
        floors.sort((a, b) => {
          // 先比较前缀
          let prefixA = a.charAt(0);
          let prefixB = b.charAt(0);
          if (prefixA !== prefixB) {
            // 如果前缀不同,则按照 A, F, B 的顺序排序
            return ['A', 'F', 'B'].indexOf(prefixA) - ['A', 'F', 'B'].indexOf(prefixB);
          } else {
            // 如果前缀相同,则根据不同的前缀进行不同的排序
            if (prefixA === 'F') {
              // F开头的元素,数字降序排序
              return parseInt(b.slice(1)) - parseInt(a.slice(1));
            } else if (prefixA === 'B') {
              // B开头的元素,数字升序排序
              return parseInt(a.slice(1)) - parseInt(b.slice(1));
            } else {
              // 其他情况,正常排序
              return a.localeCompare(b);
            }
          }
        });

        // 将RF楼层移到最前面
        let rfIndex = floors.findIndex(floor => floor === 'RF')
        if (rfIndex !== -1) {
          let rf = floors.splice(rfIndex, 1)[0];
          floors.unshift(rf);
        }
      } else {
        if (floors[0] === 'A') {
          floors = []
        }
      }
      return floors
    },
    //"系统"二级菜单的点击事件
    handleClick(item) {
      console.log('item', item);
      this.currentDevice = item.equip_code
      let floor = this.$refs.modelRef.getFloorStr(item.equip_code)
      this.$refs.modelRef.loadFloorMeshs(floor, true, item.equip_code)
      this.sidebarVisible = true;
      this.showDataInSidebar(item.equip_code);
    },
    //右侧按钮点击跳转页面
    jumpToUrl(item) {
      if (item.type.includes("panel-group")) {
        router.push({
          name: "panel-group",
          params: {
            uid: item.key,
            title: item.name,
            project_id: '82',
            project_name: '四川大厦',
          }
        })
      } else {
        // 更新弹窗中的标题
          router.push({
            name: item.key,
            params:{
              project_id: '82',
              project_name: '四川大厦',
              title: item.name,
            }
          });
      }
    },
    //子系统点击模型显示侧边栏
    subShowSidebar(data) {
      console.log('data', data);
      this.isShowParams = true
      this.isShowCanvas = true;
      let name = data.evt.source.name;
      if (name.startsWith("SCDS")) {
        let code = name.split('_')
        let i = 0;
        this.modelInfo.equip_meter_code = '';
        code.forEach(item => {
          if (i !== 5) {
            if (i !== 4) {
              this.modelInfo.equip_meter_code += (item + '_');
              i++;
            } else {
              this.modelInfo.equip_meter_code += item;
              i++
            }
          }
        })
        // console.log("====model-code",this.modelInfo.equip_meter_code)
        if (name.includes('KTTF_FCU')) {
          this.modelInfo.title = '风机盘管';
        }
        this.system_model.forEach((item) => {
          if (item.equip_code === this.modelInfo.equip_meter_code) {
            this.modelInfo.title = item.equip_name
          }
        })
        this.sidebarVisible = data.isShow;
        let n = code[4];
        let str = n.match(/[a-zA-Z]+/g);
        this.subSystemParam = system_params[str];
        // console.log("----subSystemParam", this.subSystemParam);
        //静态数据展示侧边栏模型图
        if (n.match(/[a-zA-Z]+/g)) {
          sUrl = this.bastUrl + n.match(/[a-zA-Z]+/g);
          console.log("----surl", sUrl);
          this.isModel = true;
          if (this.system_key !== "dtxt") {
            setTimeout(() => {
              this.initSubModel("subCanvas")
            }, 1000 * 2);
          }
        } else {
          this.isModel = false;
        }
      } else if (name.includes("室内环境传感器") || name.includes("CO传感器")) {
        this.modelInfo.title = name;
        this.modelInfo.equip_meter_code = '';
        this.sidebarVisible = data.isShow;
        this.subSystemParam = system_params[name];
        if (name.split('_').length > 1) {
          this.modelInfo.title = name.split('_')[0];
          this.subSystemParam =dParams[this.modelInfo.title];
          for (let key in data.HjjcT){
            if(key === name ){
              this.dPar[0].range = [data.HjjcT[key]];
            }
          }
        }
      } else if (name.includes('摄像头') || name.includes('门禁')) {
        this.sidebarVisible = data.isShow;
        this.modelInfo.title = name
        this.modelInfo.equip_meter_code = ''
        this.isShowParams = false
        this.isModel = false
        this.url = `/scds/video/afxt/video${Math.floor(Math.random() * 6) + 1}.mp4`
        this.showDTVideo('videoPlayerSXT',null, this.url)
      }else if (name.includes('XFXTBJ')){
        this.isShowCanvas = false;
        this.modelInfo.title = "F28烟感消防报警";
        this.modelInfo.equip_meter_code = '';
        this.sidebarVisible = data.isShow;
        this.subSystemParam = system_params['XFBJDB'];
        this.url = `/scds/video/afxt/video1.mp4`
        this.showDTVideo('videoPlayerSXT',null, this.url)
      }
    },
    closeSideBar() {
      this.sidebarVisible = false;
    },
    // 空调通风点击显示侧边栏
    showDataInSidebar(name) {
      this.isShowParams = true
      if (name.startsWith("SCDS")) {
        let code = name.split('_')
        let i = 0;
        this.modelInfo.equip_meter_code = '';
        code.forEach(item => {
          if (i !== 5) {
            if (i !== 4) {
              this.modelInfo.equip_meter_code += (item + '_');
              i++;
            } else {
              this.modelInfo.equip_meter_code += item;
              i++
            }
          }
        })
        if (name.includes('KTTF_FCU')) {
          this.modelInfo.title = '风机盘管';
        }
        this.system_model.forEach((item) => {
          if (item.equip_code === this.modelInfo.equip_meter_code) {
            this.modelInfo.title = item.equip_name
          }
        })
        this.sidebarVisible = true;
        let n = code[4];
        let str = n.match(/[a-zA-Z]+/g);
        this.subSystemParam = system_params[str];
        console.log("subSystemParam---", this.subSystemParam);
        //静态数据展示侧边栏模型图
        if (n.match(/[a-zA-Z]+/g)) {
          sUrl = this.bastUrl + n.match(/[a-zA-Z]+/g);
          console.log("----surl", sUrl);
          this.isModel = true;
          setTimeout(() => {
            this.initSubModel("subCanvas")
          }, 1000 * 2);
          // this.$nextTick(this.initSubModel)
        } else {
          this.isModel = false;
        }
      }
    },

    //展示放大的设备模型
    showInModal() {
      setTimeout(() => {
        this.initSubModel("bigSubCanvas")
        setTimeout(() => {
          console.log("进入弹窗参数", sub_scene, sub_scene.meshes)
          this.showSubModelParams();
        }, 2000)
      }, 1000);
    },
    showModalVideo(id) {
      if (this.url) {
        this.showDTVideo(id, null, this.url)
      } 
    },
    //展示监控视频
    showDTVideo(id, title, url = `/scds/video/dtxt/video${Math.floor(Math.random() * 2) + 1}.mp4`) {
      // console.log('url', url);
      this.url = url
      if (title) {
        this.modelInfo.title = title;
      }
      setTimeout(() => {
        // console.log("进入计时器")
        const videoDom = document.getElementById(id);
        if (videoDom) {
          // console.log("进入if语句", videoDom);
          if (url) {
            const flvVideo = flvjs.createPlayer({
              type: "mp4",
              url: baseUrl + url,
            });
            flvVideo.attachMediaElement(videoDom);
            flvVideo.load();
            flvVideo.play();
          }
        }
      }, 3000)
    },

    //监控轮巡弹窗中点击楼层事件
    clickFloorInMonitor(floor) {
      this.system_afxt = [];
      this.system_afxt_checked = [];
      this.system_afxt_floor = floor;
      system_afxt.forEach((item) => {
        if (item.floor === floor) {
          this.system_afxt.push(item);
        }
      })
    },

    //监控轮巡按钮点击数据初始化
    clickMonitor() {
      this.system_afxt_checked = [];
      this.system_afxt_floor = ''
    },

    //侧边栏模型加载方法
    initSubModel(canvasId) {
      console.log("创建画布")
      if (sub_scene) {
        sub_scene.dispose()
        sub_scene = null;
      }
      //创建一个canvas，并设置class为“canvas”
      const canvas = document.getElementById(canvasId);
      //  创建 babylonjs 3D 引擎
      if (_engine) {
        _engine = null
      }
      const engine = new BABYLON.Engine(canvas);
      engine.loadingScreen = {
        displayLoadingUI: function() {}, // 覆盖显示加载动画的方法
        hideLoadingUI: function() {}, // 覆盖隐藏加载动画的方法
        loadingUIBackgroundColor: "",
        loadingUIText: ""
      };
      engine.displayLoadingUI();

      //  创建一个场景
      sub_scene = new BABYLON.Scene(engine);
      sub_scene.clearColor = new BABYLON.Color4(0, 0, 0, 0);
      const camera = new BABYLON.ArcRotateCamera("camera1", -Math.PI / 3, Math.PI / 2.2, 6,
          new BABYLON.Vector3(0, 1, 0))
      // const camera = new BABYLON.FreeCamera("camera1", new BABYLON.Vector3(0, 5, -10), sub_scene);
      camera.attachControl(canvas, true);
      //将模型放大
      camera.wheelDeltaPercentage = 0.02;
      // 创建一个照明灯
      const light = new BABYLON.HemisphericLight(
          "light",
          new BABYLON.Vector3(0, Math.PI / 2.2, 0),
          sub_scene
      );
      // 灯光亮度
      light.intensity = 0.7;
      //外框同款材质
      let transparentMat = new BABYLON.StandardMaterial("transparentMat");
      transparentMat.alpha = 0.3;
      transparentMat.emissiveColor = new BABYLON.Color3(0.149, 0.357, 0.588);
      BABYLON.SceneLoader.Append("", sUrl + ".glb", sub_scene, () => {
        let meshes = sub_scene.meshes;
        meshes.forEach((mesh) => {
          // console.log("mesh", mesh.name, mesh.position, mesh.absolutePosition, mesh);
          if (!mesh.name.includes('equipment_') && !mesh.name.includes('root')) {
            mesh.material = transparentMat;
          }
        })
      }, () => {
      }, (scene, err) => {
        console.log('加载子模型出错了', err);
      })

      engine.runRenderLoop(() => {
        sub_scene.render();
      });

      _engine = engine;
      return sub_scene;
    },

    //展示设备大样图参数
    showSubModelParams() {
      let cStr = null; //判断是否有相同的mesh名称 sF-priamite0 sf-paraima1
      sub_scene.meshes.forEach(mesh => {
        if (!mesh.name.includes('root')) {
          let str = mesh.name.split('_')[1];
          if (str !== undefined && str !== null) {
            if (str.includes(cStr)) {
              cStr = str;
            } else {
              let array = [];
              this.subSystemParam.forEach((item) => {
                if (item.param_key.includes(str) && item.param_key.length - str.length < 3) { //包含且排除掉相同字母不同对象，SF SFILT-A
                  let params_value
                  if (item.unit.includes('||')) {
                    params_value = item.unit.split('||')[Math.round(Math.random())]
                  } else if (item.range.length < 2) {
                    params_value = item.range[0] + item.unit
                  } else if (item.range.length > 1) {
                    params_value = (Math.floor(Math.random() * (item.range[1] - item.range[0] + 1)) + item.range[0]) +
                        item.unit
                  }
                  item.params_value = params_value
                  // array 参数列表
                  array.push(item);
                }
              })
              if (array.length > 0) { //有匹配的数据才进行保存
                // console.log('需要显示参数的小球', mesh, array);
                const advancedTexture = GUI.AdvancedDynamicTexture.CreateFullscreenUI("UI");
                // 背景框
                var rect1 = new GUI.Rectangle();
                rect1.width = "280px";
                rect1.height = (20 * array.length + 20) + "px";
                rect1.cornerRadius = 5;
                rect1.color = "white";
                rect1.thickness = 0;
                ;
                rect1.background = "rgba(135, 206, 250, 0.5)";
                advancedTexture.addControl(rect1);
                rect1.linkWithMesh(mesh);
                rect1.linkOffsetY = -180;

                const stackPanel1 = new GUI.StackPanel();
                stackPanel1.isVertical = true; // 设置为垂直方向
                stackPanel1.width = "100%";
                stackPanel1.height = "100%";
                stackPanel1.paddingTop = "10px";
                stackPanel1.paddingBottom = "10px";
                rect1.addControl(stackPanel1)

                array.forEach(item => {
                  // 创建一个 StackPanel 控件
                  const stackPanel = new GUI.StackPanel();
                  stackPanel.isVertical = false; // 设置为水平方向
                  stackPanel.width = "270px";
                  stackPanel.height = "20px";
                  stackPanel1.addControl(stackPanel)


                  // 创建左对齐的 TextBlock
                  const paramsText = new GUI.TextBlock();
                  paramsText.text = item.param;
                  paramsText.width = "135px";
                  paramsText.height = "20px";
                  paramsText.paddingLeft = "20px";
                  paramsText.textHorizontalAlignment = GUI.Control.HORIZONTAL_ALIGNMENT_LEFT;
                  paramsText.textVerticalAlignment = GUI.Control.VERTICAL_ALIGNMENT_CENTER;
                  paramsText.fontSize = "16px";
                  paramsText.fontFamily = "Arial";
                  paramsText.color = "white";
                  stackPanel.addControl(paramsText);

                  // 创建右对齐的 TextBlock
                  const paramsValue = new GUI.TextBlock();
                  paramsValue.text = item.params_value;
                  paramsValue.width = "135px";
                  paramsValue.height = "20px";
                  paramsValue.paddingRight = "20px";
                  paramsValue.textHorizontalAlignment = GUI.Control.HORIZONTAL_ALIGNMENT_RIGHT;
                  paramsValue.textVerticalAlignment = GUI.Control.VERTICAL_ALIGNMENT_CENTER;
                  paramsValue.fontSize = "16px";
                  paramsValue.fontFamily = "Arial";
                  paramsValue.color = "white";
                  stackPanel.addControl(paramsValue);
                })

                // 小球
                var target = new GUI.Ellipse();
                target.width = "10px";
                target.height = "10px";
                target.thickness = 0;
                target.linkOffsetY = -20;
                target.background = "rgb(79, 177, 230)";
                advancedTexture.addControl(target);
                target.linkWithMesh(mesh);

                // 线
                var line = new GUI.Line();
                line.lineWidth = 1;
                line.color = "rgb(79, 177, 230)";
                line.y2 = 10 * (array.length + 1);
                line.linkOffsetY = -20;
                advancedTexture.addControl(line);
                line.linkWithMesh(mesh);
                line.connectedControl = rect1;
                cStr = str;
              }
            }
          }
        }
      })
    },

    //冷源系统展示 高效机房 侧边栏界面
    clickEfficientRoom() {
      this.isShowEfficientRoom = true;
      this.efficientRoom_loading = true;
    },

    //巡检弹窗数据展示
    checkClick(){
      this.OmmData.title = '巡检';
      let data = this.checkItems;
      const moment = require('moment');
      data.list.forEach((item) => {
        item.add_time = moment().format('YYYY-MM-DD HH:mm:ss');
        item.itemresult = '正常';
      })
      this.OmmData.data = data.list;
      this.OmmData.fields = data.fields;
    },

    //设备列表重置，查询
    otherSystemReset(){
      this.otherSystemData.equip_name = null;
      this.otherSystemData.floor = null;
    },

    otherSystemSubmit(){

    },

    //展示设备列表数据
    showDeviceList(){ //state
      this.otherSystemData.isShow = true;
      this.otherSystemData.tableList = [];
      this.system_model.forEach((item,index) => {
        if (item.system_key.endsWith(this.system_key)){
          item['state'] = system_params[item.equip_type_key]
          this.otherSystemData.tableList.push(item);
        }
      })
    },
  },
  watch: {
    //监听监控轮巡的视频数据，进行播放
    system_afxt_checked(newVal, oldVal) {
      console.log("--system_afxt_checked", oldVal, newVal);
      if (newVal.length > oldVal.length) {
        for (let i = oldVal.length; i < newVal.length; i++) {
          // console.log("新增视频播放", newVal[i]);
          this.showDTVideo("video" + newVal[i].equip_key, null, newVal[i].video_url);
        }
      }

    },
  },
  mounted() {
    this.handleJson()
  },
};
</script>

<template>
  <section>
    <div class="w-100" style="height: calc(100vh - 7rem)">
      <Model :systemKey="system_key || 'all'" 
            @showSidebar="subShowSidebar" 
            @showSecondNav="showSecondNav"
            @closeSideBar="closeSideBar" 
            @changeSysButtonDisabled="changeSysButtonDisabled" 
            @changeFloorButtonDisabled="changeFloorButtonDisabled"
            @changeDeviceButtonDisabled="changeDeviceButtonDisabled"  
            ref="modelRef"/>
    </div>
    <!-- 左侧导航 -->
    <div class="position-absolute " style="left: 5rem; top: 6rem;">
      <b-row>
        <b-col class="leftMenu">
          <b-button-group vertical style="padding-left: 1.25rem;padding-right: 1.25rem">
            <b-button :disabled="isSystButtonDisabled" size="sm" v-for="(item, index) in sub_system_list" :key="index" :variant="system_key === item.key
              ? 'relief-secondary'
              : 'gradient-primary'" class="mb-50" @click="clickSys(item.key)">
              <div class="mb-50" style="font-size: 1.5rem">
                <b-icon :icon="item.icon"/>
              </div>
              {{ item.name }}
            </b-button>
          </b-button-group>
        </b-col>
        <b-col class="px-0" v-if="sub_system_hover">
          <b-card no-body style="min-height: 600px; width: 260px;" @mouseleave="sub_system_hover = ''">
            <b-card-body>
              <b-card-title>{{
                  sub_system_list.find((item) => item.key === sub_system_hover)
                      .name
                }}
                <b-button class="btn-icon rounded-circle position-absolute" v-b-modal:modal-allElevator
                          style="right: 0.5rem; top: 0.9rem; z-index: 3" variant="flat-primary"
                          v-if="this.system_key === 'dtxt'">
                  显示全部电梯
                </b-button>
<!--                <b-button class="btn-icon rounded-circle position-absolute" v-b-modal.modal-otherSystem-->
<!--                          style="right: 0.5rem; top: 0.95rem; z-index: 3" variant="flat-primary" @click="showDeviceList"-->
<!--                          v-if="this.system_key !== 'dtxt' && this.system_key !== 'afxt'">-->
<!--                  设备列表-->
<!--                </b-button>-->
                <b-button class="btn-icon rounded-circle position-absolute" v-b-modal.modal-monitor
                          style="right: 0.5rem; top: 0.95rem; z-index: 3" variant="flat-primary" @click="clickMonitor"
                          v-if="this.system_key === 'afxt'">
                  监控轮巡
                </b-button>
                <b-button class="btn-icon rounded-circle position-absolute"
                          style="right: 0.5rem; top: 0.95rem; z-index: 3" variant="flat-primary"
                          @click="clickEfficientRoom"
                          v-if="this.system_key === 'zlxt'">
                  高效机房
                </b-button>
              </b-card-title>
            </b-card-body>

            <b-tabs fill>
              <b-tab title="楼层">
                <vue-perfect-scrollbar style="height: calc(100vh - 20rem)">
                  <!-- v-if="left_nav_list[system_key]"-->
                  <b-list-group flush>
                    <b-list-group-item v-for="floor in floor_list" :key="floor" @click="clickFloor(floor)" class="px-1" :active="currentFloor==floor" :disabled="isFloorButtonDisabled">
                      {{ floor }}
                    </b-list-group-item>
                  </b-list-group>
                </vue-perfect-scrollbar>
              </b-tab>
              <b-tab no-body title="设备列表" class="btn" @click="showDeviceList" v-if="this.system_key !== 'dtxt' && this.system_key !== 'afxt'">
              </b-tab>
              <b-tab title="系统">
                <vue-perfect-scrollbar style="height: calc(100vh - 20.5rem)">
                  <app-collapse accordion class="collapse-menu" v-if="left_nav_list[system_key]">
                    <app-collapse-item
                        v-for="(equip_type, equip_type_index) in Object.values(left_nav_list[system_key].equipment)"
                        :key="equip_type.equip_type_key" :title="equip_type.equip_type">
                      <template>
                        <app-collapse accordion class="collapse-menu-lvl2">
                          <app-collapse-item v-for="(floor, floor_index) in Object.values(equip_type.floor)"
                                             :key="floor.floor" :title="floor.floor">
                            <b-list-group flush>
                              <b-list-group-item v-for="(item, index) in floor.list" :key="index"
                                @click="handleClick(item)" class="px-1" :active="currentDevice == item.equip_code" :disabled="isDeviceButtonDisabled">
                                {{ item.equip_name }}
                              </b-list-group-item>
                            </b-list-group>
                          </app-collapse-item>
                        </app-collapse>
                      </template>
                    </app-collapse-item>
                  </app-collapse>
                  <div v-else style="width:100%;text-align:center;">
                    暂无系统数据
                  </div>
                </vue-perfect-scrollbar>
              </b-tab>
            </b-tabs>
          </b-card>
        </b-col>
      </b-row>

      <!--      除电梯系统外的子系统的数据展示侧边栏-->
      <b-sidebar id="slide" right shadow lazy bg-variant="white" v-model="sidebarVisible" width="380px"
                 v-if="!system_key.endsWith('dtxt')">
        <div class="d-flex h-100">
          <div class="w-100 border-right h-100">
            <vue-perfect-scrollbar style="max-height: calc(100vh - 50px)">
              <b-card-body class="content-sidebar-header">
                <b-card-title>
                  {{ modelInfo.title }}
                </b-card-title>
                <b-card-sub-title>
                  {{ modelInfo.equip_meter_code }}
                </b-card-sub-title>
              </b-card-body>

              <div class="position-relative" v-if="!system_key.endsWith('afxt')">
                <b-button class="btn-icon rounded-circle position-absolute" v-b-modal.modal-center @click="showInModal"
                          v-show="this.isModel" style="right: 0.5rem; top: 0.5rem; z-index: 3" variant="flat-primary">
                  <feather-icon icon="MaximizeIcon"/>
                </b-button>
                <!-- 模型 -->
                <canvas id="subCanvas" v-show="this.isModel" class="h-100 w-100"></canvas>
              </div>

              <div class="position-relative" v-if="system_key.endsWith('afxt') || system_key.endsWith('xfxt')">
                <b-button class="btn-icon rounded-circle position-absolute" v-b-modal.modal-video
                          @click="showModalVideo('videoPlayer')" style="right: 0.5rem; top: 0.5rem; z-index: 3"
                          variant="flat-primary">
                  <feather-icon icon="MaximizeIcon"/>
                </b-button>
                <!-- 视频 -->
                <video id="videoPlayerSXT" class="w-100 h-100"></video>
              </div>

              <app-collapse class="infoCollapse" v-if="isShowParams">
                <!-- 状态参数 -->
                <app-collapse-item title="状态参数" :isVisible="true">
                  <div style="display: flex;justify-content: center"
                       v-if="subSystemParam === undefined || subSystemParam === null">
                    <span style="color: gray">暂无数据</span>
                  </div>
                  <div style="display: flex; justify-content: space-between; padding:0.3rem 0;"
                       v-for="(item, index) in this.subSystemParam" :key="index" v-if="!item.param.includes('控制')">
                    <span>
                      {{ item.param }}
                    </span>
                    <span v-if="!item.unit.includes('||') && item.range.length > 1">
                      {{ Math.floor(Math.random() * (item.range[1] - item.range[0] + 1)) + item.range[0] }}{{
                        item.unit
                      }}
                    </span>
                    <span v-else-if="!item.unit.includes('||') && item.range.length < 2">
                      {{ item.range[0] }}{{ item.unit }}
                    </span>
                    <span v-else>
                      {{ item.unit.split('||')[Math.round(Math.random())] }}
                    </span>
                  </div>
                </app-collapse-item>

                <app-collapse-item title="控制参数" :isVisible="true">
                  <div style="display: flex;justify-content: center"
                       v-if="subSystemParam === undefined || subSystemParam === null">
                    <span style="color: gray">暂无数据</span>
                  </div>
                  <div style="display: flex; justify-content: space-between; padding:0.1rem 0;"
                       v-for="(item, index) in this.subSystemParam" :key="index" v-if="item.param.includes('控制')">
                    <span>
                      {{ item.param }}
                    </span>
                    <span v-if="!item.unit.includes('||') && item.range.length > 1">
                      {{ Math.floor(Math.random() * (item.range[1] - item.range[0] + 1)) + item.range[0] }}{{
                        item.unit
                      }}
                    </span>
                    <span v-if="!item.unit.includes('||') && item.range.length < 2">
                      {{ item.range[0] }}{{ item.unit }}
                    </span>
                    <span v-else-if="item.unit.includes('||')">
                      <b-form-checkbox name="check-button" switch>
                        {{ item.unit.split("||")[Math.round(Math.random())] }}
                      </b-form-checkbox>
                    </span>
                  </div>
                  <div style="display: flex;justify-content: space-between;padding:0.1rem 0; ">
                    <span>
                      <b-form-checkbox switch>强制</b-form-checkbox>
                    </span>
                    <span>
                      <b-button variant="primary" size="sm">设定</b-button>
                    </span>
                  </div>
                </app-collapse-item>
                <app-collapse-item title="运维监测" :isVisible="true">
                  <div class="d-flex justify-content-around text-center">
                    <div>
                      <div @click="OmmData.title='保养'; OmmData.data = maintainItems;OmmData.fields = null" v-b-modal.modal-OMM>
                        <b-avatar rounded variant="light-primary" >
                          5
                        </b-avatar>
                      </div>
                      <div>保养</div>
                    </div>
                    <div>
                      <div @click="OmmData.title='故障'; OmmData.data = faultItems;OmmData.fields = null" v-b-modal.modal-OMM>
                      <b-avatar rounded variant="light-primary" >
                        2
                      </b-avatar>
                      </div>
                      <div>故障</div>
                    </div>
                    <div>
                      <div @click="OmmData.title='维修'; OmmData.data = repaireItems;OmmData.fields = null" v-b-modal.modal-OMM>
                      <b-avatar rounded variant="light-primary">
                        2
                      </b-avatar>
                      </div>
                      <div>维修</div>
                    </div>
                    <div>
                      <div @click="checkClick" v-b-modal.modal-OMM>
                      <b-avatar rounded variant="light-primary">
                        20
                      </b-avatar>
                      </div>
                      <div>巡检</div>
                    </div>
                  </div>
                  <hr class="mb-0"/>
                  <app-collapse accordion class="infoCollapse">
                    <app-collapse-item title="保养记录">
                      <b-table responsive="sm" :items="maintainItems"/>
                    </app-collapse-item>

                    <app-collapse-item title="故障记录">
                      <b-table responsive="sm" :items="faultItems"/>
                    </app-collapse-item>

                    <app-collapse-item title="维修记录">
                      <b-table responsive="sm" :items="repaireItems"/>
                    </app-collapse-item>
                  </app-collapse>
                  <div class="p-2">
                    <b-btn variant="primary" size="sm">操作手册</b-btn>
                    <b-btn variant="primary" size="sm" class="mx-1">工程图纸</b-btn>
                  </div>
                </app-collapse-item>
              </app-collapse>
            </vue-perfect-scrollbar>
          </div>
        </div>
      </b-sidebar>
      <!--电梯系统单独的侧边栏-->
      <b-sidebar right shadow lazy bg-variant="white" v-model="sidebarVisible" width="380px"
                 v-if="system_key.endsWith('dtxt')">
        <vue-perfect-scrollbar style="max-height: calc(100vh - 50px)">
          <div class="d-flex h-100">
            <div class="w-100 h-100">
              <b-card-body class="content-sidebar-header">
                <b-card-title>
                  {{ modelInfo.title }}
                  <b-button v-b-modal.modal-video class="btn-icon rounded-circle position-absolute"
                            style="right: 1rem; top: 42px; z-index: 3" variant="flat-primary"
                            @click="showDTVideo('videoPlayer', modelInfo.title)">
                    <b-icon-play-btn-fill/>
                  </b-button>
                  <!--                  <b-button v-b-modal.modal-video class="btn-icon rounded-circle position-absolute"-->
                  <!--                            style="right: 1rem; top: 42px; z-index: 3" variant="flat-primary"-->
                  <!--                            @click="showDTVideo('videoPlayer')">-->
                  <!--                    <b-icon-play-btn-fill/>-->
                  <!--                  </b-button>-->
                </b-card-title>
                <b-card-sub-title>
                  {{ modelInfo.equip_meter_code }}
                </b-card-sub-title>
              </b-card-body>
              <b-card-body>
                <b-card-text>
                  <b-row>
                    <b-col class="text-center" cols="6">
                      <b-badge class="p-1 w-100" style="font-size: 1rem" variant="light-success">
                        <div class="text-truncate">
                          {{ dtDate.YXZT[Math.round(Math.random())] }}
                        </div>
                      </b-badge>
                      <label>运行状态</label>
                    </b-col>

                    <b-col class="text-center" cols="6">
                      <b-badge class="p-1 w-100" style="font-size: 1rem" variant="light-warning">
                        {{ Math.round(Math.random() * 100) }}%
                      </b-badge>
                      <label>载客率</label>
                    </b-col>
                  </b-row>

                  <b-row>
                    <b-col class="text-center mt-1" cols="6">
                      <b-badge class="p-1" style="font-size: 1rem" variant="light-primary">
                        {{ dtDate.LC[Math.round(Math.random() * 30) + 1] }}
                      </b-badge>
                      <br/>
                      <label>停靠楼层</label>
                    </b-col>

                    <b-col class="text-center mt-1" cols="6">
                      <b-badge class="p-1" style="font-size: 1rem" variant="light-secondary">
                        {{ dtDate.LC[Math.round(Math.random() * 30) + 1] }}
                      </b-badge>
                      <br/>
                      <label>目标楼层</label>
                    </b-col>
                  </b-row>

                  <b-row>
                    <b-col cols="6" class="mt-1">
                      <b-card bg-variant="light-secondary" class="text-center mb-1 pt-50" no-body style="height: 5rem">
                        <span class="mt-50">
                          <b-icon-caret-up-fill v-if="
                            true
                          " scale="1.5" variant="primary"/>
                          <b-icon-caret-down-fill v-else-if="
                            false
                          " scale="1.5" variant="primary"/>
                          <b-icon-stop-fill v-else scale="1.5" variant="primary"/>
                        </span>
                        <label>运行方向</label>
                      </b-card>
                    </b-col>

                    <b-col cols="6" class="mt-1">
                      <b-card bg-variant="light-secondary" class="mb-1" no-body style="height: 5rem">
                        <div class="d-flex justify-content-between" style="height: 5rem">
                          <div :class="'l'" style="
                                            background: #1890ff;
                                            border-top-left-radius: 5px;
                                            border-bottom-left-radius: 5px;
                                            height: 100%;
                                        "></div>
                          <div :class="'l'
                            " style="
                              background: #1890ff;
                              border-top-right-radius: 5px;
                              border-bottom-right-radius: 5px;
                              height: 100%;
                          "></div>

                        </div>
                      </b-card>
                    </b-col>
                  </b-row>
                  <hr style="margin-left: -1.5rem; margin-right: -1.5rem"/>

                  <vue-slider :adsorb="true" :value="dtDate.LC[Math.round(Math.random() * 30) + 1]" :data="dtDate.LC"
                              class="vue-slide-primary" height="700px" direction="btt" tooltip="always" disabled
                              style="margin: 2rem auto"
                              :marks="true"></vue-slider>
                  <hr style="margin-left: -1.5rem; margin-right: -1.5rem"/>
                  <div style="color: #d0d2d6 !important;">
                    <div class="collapse-title" style="padding: 1rem 2.8rem 1.5rem 0rem !important;">
                      <span>运维监测</span>
                    </div>
                    <div class="d-flex justify-content-around text-center">
                      <div>
                        <b-avatar button rounded variant="light-primary" v-b-modal:modal-OMM>
                          5
                        </b-avatar>
                        <div>保养</div>
                      </div>
                      <div>
                        <b-avatar button rounded variant="light-primary">
                          2
                        </b-avatar>
                        <div>故障</div>
                      </div>
                      <div>
                        <b-avatar button rounded variant="light-primary">
                          2
                        </b-avatar>
                        <div>维修</div>
                      </div>
                      <div>
                        <b-avatar button rounded variant="light-primary">
                          256
                        </b-avatar>
                        <div>巡检</div>
                      </div>
                    </div>

                    <hr class="mb-0"/>

                    <app-collapse accordion class="infoCollapse">
                      <app-collapse-item title="保养记录">
                        <b-table responsive="sm" :items="maintainItems"/>
                      </app-collapse-item>

                      <app-collapse-item title="故障记录">
                        <b-table responsive="sm" :items="faultItems"/>
                      </app-collapse-item>

                      <app-collapse-item title="维修记录">
                        <b-table responsive="sm" :items="repaireItems"/>
                      </app-collapse-item>
                    </app-collapse>
                    <hr class="mb-0"/>
                    <div class="p-2">
                      <b-btn variant="primary" size="sm">操作手册</b-btn>
                      <b-btn variant="primary" size="sm" class="mx-1">工程图纸</b-btn>
                    </div>
                  </div>
                </b-card-text>
              </b-card-body>
            </div>
          </div>
        </vue-perfect-scrollbar>
      </b-sidebar>
      <!--      制冷系统高效机房侧边栏-->
      <b-sidebar bg-variant="white" lazy right shadow v-model="isShowEfficientRoom" width="90vw" no-header>
        <template #default="{ hide }">
          <div style="height: 100vh;position: relative">
            <b-button-close @click="hide" style="position: absolute;top: 10px;left: 10px;z-index: 3"></b-button-close>
            <div id="roomLoading" v-show="efficientRoom_loading"
                 style="position: absolute;top: 50%;left: 50%;transform: translate(-50%, -50%);">
              <b-spinner label="Loading..." style="width: 5rem; height: 5rem;"></b-spinner>
            </div>
            <b-embed type="iframe"
                     aspect="1by1"
                     src="http://p4.inwhile.com:7622/webPublish?pid=150000686&userName=gjkj&userPwd=gjkj1234"
                     allowfullscreen
                     @onload="this.efficientRoom_loading = false"
            >
            </b-embed>
          </div>
        </template>
      </b-sidebar>
    </div>
    <!--放大模型的弹窗-->
    <b-modal id="modal-center" centered hide-footer size="xl" :title="modelInfo.title" content-class="my-modal-content"
             dialog-class="my-dialog-class">
      <canvas id="bigSubCanvas" class="h-100 w-100"></canvas>
    </b-modal>
    <!-- 显示全部电梯状态列表的弹窗-->
    <b-modal id="modal-allElevator" centered hide-footer size="xl" title="电梯状态列表"
             content-class="my-modal-content-allElevator" dialog-class="my-dialog-class">
      <div class="modal-allElevator-div">
        <!--        左边的列表-->
        <div>
          <b-card style="width: 290px">
            <b-card-title>选择电梯</b-card-title>
            <b-card-text>
              <b-form-group>
                <b-form-checkbox-group v-model="system_dtxt_checked">
                  <b-row>
                    <b-col cols="6" class="mb-3" v-for="(item, index) in this.system_dtxt" :key="index">
                      <b-form-checkbox :value="item">{{ item.equip_name }}</b-form-checkbox>
                    </b-col>
                  </b-row>
                </b-form-checkbox-group>
              </b-form-group>
            </b-card-text>
          </b-card>
        </div>
        <!--        右边电梯的展示-->
        <div>
          <b-row cols="12">
            <b-col v-for="(item, index) in this.system_dtxt_checked" :key="index" cols="3">
              <div>
                <b-card-body class="content-sidebar-header">
                  <b-card-title>
                    {{ item.equip_name }}
                    <b-button v-b-modal.modal-video class="btn-icon rounded-circle position-absolute"
                              style="right: 1rem; top: 42px; z-index: 3" variant="flat-primary"
                              @click="showDTVideo('videoPlayer', item.equip_name)">
                      <b-icon-play-btn-fill/>
                    </b-button>
                  </b-card-title>
                  <b-card-sub-title>
                    {{ item.equip_code }}
                  </b-card-sub-title>
                </b-card-body>
                <b-card-body>
                  <b-card-text>
                    <b-row>
                      <b-col class="text-center" cols="6">
                        <b-badge class="p-1 w-100" style="font-size: 1rem" variant="light-success">
                          <div class="text-truncate">
                            {{ dtDate.YXZT[Math.round(Math.random())] }}
                          </div>
                        </b-badge>
                        <label>运行状态</label>
                      </b-col>

                      <b-col class="text-center" cols="6">
                        <b-badge class="p-1 w-100" style="font-size: 1rem" variant="light-warning">
                          {{ Math.round(Math.random() * 100) }}%
                        </b-badge>
                        <label>载客率</label>
                      </b-col>
                    </b-row>

                    <b-row>
                      <b-col class="text-center mt-1" cols="6">
                        <b-badge class="p-1" style="font-size: 1rem" variant="light-primary">
                          {{ dtDate.LC[Math.round(Math.random() * 30) + 1] }}
                        </b-badge>
                        <br/>
                        <label>停靠楼层</label>
                      </b-col>

                      <b-col class="text-center mt-1" cols="6">
                        <b-badge class="p-1" style="font-size: 1rem" variant="light-secondary">
                          {{ dtDate.LC[Math.round(Math.random() * 30) + 1] }}
                        </b-badge>
                        <br/>
                        <label>目标楼层</label>
                      </b-col>
                    </b-row>

                    <b-row>
                      <b-col cols="6" class="mt-1">
                        <b-card bg-variant="light-secondary" class="text-center mb-1 pt-50" no-body
                                style="height: 5rem">
                          <span class="mt-50">
                            <b-icon-caret-up-fill v-if="
                              true
                            " scale="1.5" variant="primary"/>
                            <b-icon-caret-down-fill v-else-if="
                              false
                            " scale="1.5" variant="primary"/>
                            <b-icon-stop-fill v-else scale="1.5" variant="primary"/>
                          </span>
                          <label>运行方向</label>
                        </b-card>
                      </b-col>

                      <b-col cols="6" class="mt-1">
                        <b-card bg-variant="light-secondary" class="mb-1" no-body style="height: 5rem">
                          <div class="d-flex justify-content-between" style="height: 5rem">
                            <div :class="'l'" style="
                                              background: #1890ff;
                                              border-top-left-radius: 5px;
                                              border-bottom-left-radius: 5px;
                                              height: 100%;
                                          "></div>
                            <div :class="'l'
                              " style="
                                background: #1890ff;
                                border-top-right-radius: 5px;
                                border-bottom-right-radius: 5px;
                                height: 100%;
                            "></div>

                          </div>
                        </b-card>
                      </b-col>
                    </b-row>
                    <hr style="margin-left: -1.5rem; margin-right: -1.5rem"/>

                    <vue-slider :adsorb="true" :value="dtDate.LC[Math.round(Math.random() * 30) + 1]" :data="dtDate.LC"
                                class="vue-slide-primary" height="700px" direction="btt" tooltip="always"
                                style="margin: 2rem auto" :marks="true"></vue-slider>
                    <hr style="margin-left: -1.5rem; margin-right: -1.5rem"/>
                  </b-card-text>
                </b-card-body>
              </div>
            </b-col>
          </b-row>
        </div>
      </div>

    </b-modal>
    <!--电梯监控视频的弹窗-->
    <b-modal id="modal-video" centered hide-footer size="xl" :title="modelInfo.title" content-class="my-modal-content"
             dialog-class="my-dialog-class">
      <!-- 去掉 controls 则不显示进度条-->
       <video id="videoPlayer" style="width: 100%;height: 65vh;">
      </video>
    </b-modal>
    <!--    安防系统监控轮巡弹窗 modal-monitor-->
    <b-modal id="modal-monitor" centered hide-footer size="xl" title="监控轮巡" content-class="my-modal-content-monitor"
             dialog-class="my-dialog-class">
      <div style="display: flex;justify-content: space-between;">
        <!-- 左边的楼层-->
        <div style="width: 10vw">
          <vue-perfect-scrollbar style="height: calc(100vh - 20rem)">
            <!-- v-if="left_nav_list[system_key]"-->
            <b-list-group flush>
              <b-list-group-item v-for="floor in floor_list" :key="floor" @click="clickFloorInMonitor(floor)"
                                 class="px-1" :active="system_afxt_floor == floor">
                {{ floor }}
              </b-list-group-item>
            </b-list-group>
          </vue-perfect-scrollbar>
        </div>
        <!-- 右边的主体框架-->
        <div style="width: 67vw">
          <!-- 上半部分的监控列表-->
          <div>
            <h2 class="text-center">{{ this.system_afxt_floor }}</h2>
            <div class="mt-2">
              <b-form-group v-slot="{ ariaDescribedby }">
                <b-form-checkbox-group :aria-describedby="ariaDescribedby" name="flavour-2"
                                       v-model="system_afxt_checked">
                  <b-row>
                    <b-col md="6" lg="3" v-for="(item, index) in system_afxt" :key="index">
                      <b-form-checkbox :value="item">
                        <span>
                          {{ item.equip_name }}
                          <small class="ml-50">({{ item.equip_code }})</small>
                        </span>
                      </b-form-checkbox>
                    </b-col>
                  </b-row>
                </b-form-checkbox-group>
              </b-form-group>
            </div>
          </div>
          <!-- 下半部分的监控小窗-->
          <div>
            <b-row class="mt-2">
              <b-col cols="3" v-for="(item, index) in system_afxt_checked" :key="index">
                <b-card>
                  <h5>
                    {{
                      item.equip_name
                    }}<small class="ml-50">({{ item.equip_code }})</small>
                  </h5>
                  <div>
                    <b-button class="btn-icon rounded-circle position-absolute" v-b-modal.modal-video
                              @click="showDTVideo('videoPlayer', item.equip_name, item.video_url)"
                              style="right: 0; top: 0.5rem;padding: 0.2rem; z-index: 3" variant="flat-primary">
                      <feather-icon icon="MaximizeIcon"/>
                    </b-button>
                  </div>
                  <!-- 视频 -->
                  <div class="position-relative w-100" style="height: 16rem; background-color: rgba(0, 0, 0, 0.5)">
                    <video :id="'video' + item.equip_key" class="h-100 w-100"></video>
                  </div>

                </b-card>
              </b-col>
            </b-row>
          </div>
        </div>
      </div>
    </b-modal>

    <!-- 运维监测的弹窗-->
    <b-modal id="modal-OMM" centered hide-footer size="xl" :title="OmmData.title"
             content-class="my-modal-content-modal-OMM"
             dialog-class="my-dialog-class">
      <b-table responsive="sm" :items="OmmData.data" :fields="OmmData.fields"/>
    </b-modal>

<!--    其他子系统的设备列表-->
    <b-modal id="modal-otherSystem" centered hide-footer size="xl" title="设备列表" v-model="otherSystemData.isShow"
             content-class="my-modal-content-otherSystem"
             dialog-class="my-dialog-class">
      <div style="display: flex;justify-content: space-between">
        <!--      搜索框-->
        <div style="width: 15vw">
          <b-card>
            <b-card-title>筛选</b-card-title>
            <label>设备名称</label>
            <b-form-input
                placeholder="输入设备名称查询"
                v-model="otherSystemData.equip_name"
                trim
            ></b-form-input>

            <label class="mt-1">楼层</label>
            <b-form-select
                class="w-100"
                id="input-3"
                v-model="otherSystemData.floor"
                :options="floor_list"
                clearable
                required
            ></b-form-select>
            <div class="text-right mt-2">
              <b-btn class="mr-1" @click="otherSystemReset">重置</b-btn>
              <b-btn variant="primary" @click="otherSystemSubmit">查询</b-btn>
            </div>
          </b-card>
        </div>
        <!--      table列表-->
        <div style="width: 75vw">
          <b-table striped hover :items="otherSystemData.tableList" :fields="otherSystemData.fields">
            <template #cell(id)="data">
              {{ data.index + 1 }}
            </template>
            <template #cell(操作)="data">
              <b-button variant="success">详情</b-button>
            </template>
          </b-table>
        </div>
      </div>
    </b-modal>
    <!-- 右侧导航 -->
    <div class="position-absolute leftMenu" style="right: 5rem; top: 6rem;">
      <b-button-group vertical style="padding-left: 1.25rem;padding-right: 1.25rem">
        <b-button stacked size="sm" v-for="(item, index) in add_system_list" :key="index" variant="gradient-primary"
                  class="mb-50" @click="jumpToUrl(item)">
          <div class="mb-50" style="font-size: 1.2rem">
            <b-icon :icon="item.icon"/>
          </div>
          {{ item.name }}
        </b-button>
      </b-button-group>
    </div>
  </section>
</template>

<style lang="scss">
.my-modal-content {
  width: 60vw;
}

.my-modal-content-allElevator {
  width: 70vw;
}

//监控轮巡弹窗css
.my-modal-content-monitor {
  width: 80vw;
}


.my-modal-content-modal-OMM{
  width: 60vw;
}

.my-modal-content-otherSystem{
  width: 90vw;
}

.my-dialog-class {
  display: flex;
  align-items: center;
  justify-content: center;
}

.modal-allElevator-div {
  display: flex;
  justify-content: space-between;
}

.scrollable-list {
  max-height: 500px;
  /* 设置最大高度 */
  overflow-y: auto;
  /* 当内容超出时显示滚动条 */
}

.l {
  width: 48%;
  animation: long 300ms linear;
}

.s {
  width: 15%;
  animation: short 300ms linear;
}

.offsetMargin {
  margin-left: -1.5rem;
  margin-right: -1.5rem;
}

.infoCollapse {
  .card {
    box-shadow: none;
  }

  color: #d0d2d6 !important;
}

::v-deep .bi-x.b-icon.bi {
  color: white !important;
  height: 30px;
  width: 30px;
}

.leftMenu {
  // position: fixed;
  // z-index: 1;
  // top: 5rem;
  // left: 2rem;
  height: calc(100vh - 10rem);
  // width: 10rem;
  padding-top: 2rem;
  padding-left: 0rem;
  padding-right: 0rem;
  // background: rgba(0, 0, 0, 0.3);
}

//设备模型参数弹窗
.meshInfoCard {
  color: whitesmoke;
  width: 250px;
  padding: 0.2rem 0.1rem;
  border-radius: 4px;
  backdrop-filter: blur(1px);
}
</style>
